import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import { BasketPage } from '@features/basket';
import { useCart } from '@hooks/useCart.ts';

export const Route = createFileRoute('/c/$orgId/$portalId/basket')({
  component: RouteComponent,
  beforeLoad: () => {
    useCart.setState({ wizardStepId: 'basket' });
  },
});

function RouteComponent() {
  return (
    <UserLayout containerClassName="bg-white" hideBottomMenu>
      {/* Zamerne ne `container`: tailwind.config.js prepisuje `screens` a nejmensi z nich
          (tiles-1: 289px) tim clampne `container` na 289px — na 390px mobilu se stranka
          smrskla do prostredniho pruhu. Sirku uz resi max-w-[1200px] v BasketPage. */}
      <div className="w-full mx-auto px-0 py-4 md:px-4 md:py-8">
        <BasketPage />
      </div>
    </UserLayout>
  );
}
